<mat-accordion multi="true">
    <div class="file-container">
        <!-- DRAG & DROP FILE  -->
        <div class="file-import-container" style="background-color: white;" appDragDrop
            (onFileDropped)="getFileDetails($event)">
            <div class="file-import-content">
                <button class="btn-browse" (click)="checkModifiedData()">Import</button>
                <input hidden type="file" name="fileImport" accept=".kml,.itn,.gpx,.csv,.itf,.sif" #fileImport (change)="getFileDetails($event);">
            </div>
        </div>
    </div>
</mat-accordion>
